module.exports = window["wp"]["editor"];